import { queryOptions, skipToken, useMutation } from "@tanstack/react-query";
import type {
  AdditionalService,
  GetFlightAvailabilityTokenOutputDto,
  GetFlightAvailabilityTokenOutputDtoV2,
} from "../types/codegen";
import api from "@/app/lib/api/api";
import { BASE_API_URL_V2 } from "../routes";

interface FlightAvailabilityParams {
  index: string;
  searchResultKey: string;
  searchResultToken: string;
  itineraryIndex: number;
  mandatoryServices?: AdditionalService[];
  optionalServices?: AdditionalService[];
}

export const flightAvailabilityQueryOptions = (
  params: FlightAvailabilityParams | null,
) =>
  queryOptions({
    queryKey: ["flight-availability", params] as const,
    queryFn: params
      ? ({ signal }) =>
          api.post<GetFlightAvailabilityTokenOutputDtoV2>(
            `/flights/${params.index}/availability`,
            params,
            {
              signal,
              baseURL: BASE_API_URL_V2,
            },
          )
      : skipToken,
    select: (data) => data.data.data,
    enabled: !!params,
    throwOnError: false,
    refetchOnMount: true,
    staleTime: 1000 * 5, // 5 seconds
  });

export const useFlightAvailabilityMutation = ({
  onSuccess,
}: {
  onSuccess: (data: GetFlightAvailabilityTokenOutputDto) => void;
}) =>
  useMutation({
    mutationFn: (params: FlightAvailabilityParams) =>
      api.post<GetFlightAvailabilityTokenOutputDto>(
        `/flights/${params.index}/availability`,
        params,
      ),
    onSuccess: (data) => onSuccess(data.data),
  });
